<template>
  <div>
    <router-view style="width:100%;height:100%;"></router-view>
    <div>
      <div class="header-img">
        <div class="header-text">
          <h1>新闻中心</h1>
          <h2>News Center</h2>
        </div>
      </div>
      <div class="presscenter-contain">
        <div class="serveCase-contain">
          <div class="serveCase-left">
            <div>
              您的位置：
              <router-link tag="a" to="Home" class="home-title"
                >首页</router-link
              ><i class="fa fa-angle-right" aria-hidden="true"></i
              ><router-link tag="a" to="News" class="new-name"
                >新闻中心</router-link
              >
            </div>
          </div>
          <div class="serveCase-tab">
            <div
              v-for="(item, index) in tabData"
              :key="index"
              @click="serveChange(item)"
            >
              <router-link
                tag="a"
                :to="{ path: 'News', query: { type: item.name } }"
                class="tabName"
                :class="item.id == tabs ? 'active' : 'tabName'"
              >
                {{ item.name }}
              </router-link>
            </div>
          </div>
        </div>
        <div
          class="news-contain"
          v-for="(item, index) in News"
          :key="index"
          :class="item.className"
        >
          <router-link tag="a" :to="item.url" class="news-left">
            <img :src="item.img" :alt="item.title" />
          </router-link>
          <router-link tag="a" :to="item.url" class="news-center">
            <h1 class="news-title">
              {{ item.title }}
            </h1>
            <div class="news-content">
              {{ item.name }}
            </div>
          </router-link>
          <div class="news-right">
            <div class="news-date">{{ item.date }}</div>
            <router-link tag="a" :to="item.url" class="new-more">
              <span>MORE</span>
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </router-link>
          </div>
        </div>
        <div class="pagination">
          <el-pagination
            class="text-center"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="PageIndex"
            :page-size="PageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="Total"
          >
          </el-pagination>
        </div>
      </div>
      <bottom></bottom>
    </div>
  </div>
</template>

<script>
import bottom from "@/components/bottom";
export default {
  components: {
    bottom
  },
  data() {
    return {
      tabs: 1,
      type: "",
      tabData: [
        { name: "全部", id: 1 },
        { name: "医疗资讯", id: 2 },
        { name: "培训中心", id: 3 }
      ],
      newsData: [
        {
          img: "../../../../static/images/news11.png",
          title:
            "前海高扬联合创办并授牌100个中心城市的线下实体“好医工 – 共享服务中心”",
          type: "医疗资讯",
          name:
            "2021年4月10日，在第十一届中国医疗设备行业数据发布大会上，《中国医疗设备》杂志社作为创始人，深圳前海高扬科技有限公司和国科恒泰（北京）医疗科技股份有限公司作为联合创始人，共同创立并授牌100个中心城市的线下...",
          date: "2021-05-07",
          url: "/News/6",
          className: "news-text1"
        },
        {
          img: "../../../../static/images/news1.png",
          title: "2020年为什么这么多医疗器械公司一直招人",
          type: "医疗资讯",
          name:
            "年后医疗器械招聘猛增，尤其是医疗器械维修工程师岗位，我所在的X射线细分领域来说，具体有以下几方面：首先，在疫情期间，DR设备的采购在3-4月份进入了峰值。特别是移动机的采购需求量猛增。比如说纽约州在3月份...",
          date: "2021-02-28",
          url: "/News/1",
          className: "news-text1"
        },
        {
          img: "../../../../static/images/news2.png",
          title: "如何使医疗设备发挥出最佳的功能日益重要",
          type: "医疗资讯",
          name:
            "医疗设备是医院的物质基础，是现代化程度的重要标志，在医疗诊断过程中发挥着举足轻重的作用。如何使医疗设备发挥出最佳的功能日益重要。作为医学工程的主体-医学工程人员，如何最大限度的发挥自己的主观能动性...",
          date: "2021-02-26",
          url: "/News/2",
          className: "news-text1"
        },
        {
          img: "../../../../static/images/news3.png",
          title: "医疗器械行业趋势及设备维修技术探讨",
          type: "医疗资讯",
          name:
            "根据医疗器械相关法规，医疗器械使用单位对需要定期检查、检验、校准、保养、维护的医疗器械，应当按照产品说明书的要求进行检查、检验、校准、保养、维护并予以记录，及时进行分析、评估，确保医疗器械处于良好状态...",
          date: "2021-02-26",
          url: "/News/3",
          className: "news-text1"
        },
        {
          img: "../../../../static/images/news4.png",
          title: "医疗器械的售后维修服务正逐渐成为下一个风口",
          type: "医疗资讯",
          name:
            "随着近年来医疗器械产品与信息技术的不断升级，第三方医疗器械维修公司也纷纷依托大数据、人工智能技术开启“云售后服务”时代，通过远程指导与操作，在监控设备状态、基础维修等方面提供技术保障。专家表示...",
          date: "2021-02-26",
          url: "/News/4",
          className: "news-text1"
        },
        {
          img: "../../../../static/images/news5.png",
          title: "医疗设备日常巡检保养的重要性",
          type: "医疗资讯",
          name:
            "当前医院医疗设备故障很大一部分是由于巡检保养没有到位的原因引起的，完善医疗设备巡检制度，是保证医疗设备完好及正常使用的重要方面，在医疗设备巡检制度实施和不断完善的过程中，为不断提升医院设备维修管理的内涵...",
          date: "2021-02-26",
          url: "/News/5",
          className: "news-text1"
        }
      ],
      // 分页
      PageIndex: 1,
      PageSize: 10,
      Total: 6
    };
  },
  mounted() {
    if (!this.$route.query.type || this.$route.query.type === "全部") {
    } else {
      var type = this.$route.query.type;
      var tab = this.tabData.find(x => x.name === type);
      if (tab) {
        this.type = tab.name;
        this.tabs = tab.id;
      }
    }
  },
  computed: {
    News: vm => {
      return !vm.type || vm.type === "全部"
        ? vm.newsData
        : vm.newsData.filter(item => item.type === vm.type);
    }
  },
  methods: {
    serveChange(e) {
      this.tabs = e.id;
      this.type = e.name;
    },
    handleSizeChange(pageSize) {
      this.PageSize = pageSize;
    },
    handleCurrentChange(index) {
      this.PageIndex = index;
    }
  }
};
</script>

<style scoped lang="less">
.header-img {
  width: 100%;
  height: 300px;
  background: url(../../../static/images/server9.png) no-repeat center center;
  background-size: 100% 100%;
  .header-text {
    width: 1170px;
    margin: 0 auto;
    padding-top: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    h1 {
      color: #ffffff;
      font-size: 28px;
      font-weight: 300;
      letter-spacing: 2px;
      line-height: 0;
    }
    h2 {
      width: 13%;
      color: #ffffff;
      font-size: 20px;
      opacity: 0.9;
      padding: 1px 10px 1px;
      margin: 10px 0;
      line-height: 1px;
      border-left: 130px solid #ddd;
      border-right: 130px solid #ddd;
      text-align: center;
      font-family: "FZCYJ";
      letter-spacing: 1px;
      font-weight: 300;
    }
  }
}
.presscenter-contain {
  width: 1170px;
  margin: 0 auto;
  margin-bottom: 60px;
  .serveCase-contain {
    width: 100%;
    height: 120px;
    display: flex;
    flex-direction: row;
    .serveCase-left {
      width: 75%;
      height: 100px;
      display: flex;
      flex-direction: row;
      align-items: center;
      color: #666666;
      font-size: 12px;
      .home-title {
        cursor: pointer;
        color: #666666;
        &:hover {
          color: #3488ea;
        }
      }
      .new-name {
        color: #3488ea;
        cursor: pointer;
      }
      .fa-angle-right {
        margin: 0 5px;
      }
    }
    .serveCase-tab {
      width: 25%;
      height: 100px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-around;
      .tabName {
        width: 66px;
        height: 30px;
        display: block;
        color: #666666;
        font-size: 14px;
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        &:hover {
          color: #fff;
          background: #3488ea;
        }
      }
      .active {
        width: 66px;
        height: 30px;
        display: block;
        color: #fff;
        font-size: 14px;
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        background: #3488ea;
      }
    }
  }
  .news-contain {
    width: 100%;
    height: 160px;
    border-bottom: 1px solid #e5e5e5;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
    .news-left {
      width: 24%;
      overflow: hidden;
      img {
        width: 100%;
        height: 136px;
        display: block;
        cursor: pointer;
        transform: scale(1);
        transition: all 1s;
      }
    }
    .news-center {
      width: 62%;
      .news-title {
        color: #666666;
        font-size: 16px;
        font-weight: 300;
        margin-top: 25px;
        line-height: 12px;
        cursor: pointer;
        transform: translateX(0);
        transition: all 0.5s;
      }
      .news-content {
        color: #999999;
        font-size: 14px;
        margin-top: 10px;
        font-weight: 300;
        line-height: 24px;
        cursor: pointer;
        transform: translateX(0);
        transition: all 0.5s;
      }
    }
    .news-right {
      width: 10%;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .news-date {
        color: #666666;
        font-size: 14px;
        margin-top: 20px;
        font-family: "FZCYJ";
        letter-spacing: 1px;
      }
      .new-more {
        width: 89px;
        height: 33px;
        border: 1px solid #e5e5e5;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        color: #666666;
        font-size: 13px;
        margin-top: 60px;
        cursor: pointer;
        font-family: "FZCYJ";
        letter-spacing: 1px;
        transition: all 0.5s;
        .fa-angle-right {
          margin-left: 6px;
        }
      }
    }
  }
  .pagination {
    margin-top: 40px;
  }
}
.text-center {
  text-align: center;
}

.news-text1:hover {
  .news-left {
    width: 24%;
    overflow: hidden;
    img {
      width: 100%;
      height: 136px;
      transform: scale(1.1);
      transition: all 1s;
    }
  }
  .news-center {
    .news-title {
      color: #3488ea;
      transform: translateX(15px);
      transition: all 0.5s;
    }
    .news-content {
      transform: translateX(15px);
      transition: all 0.5s;
    }
  }
  .new-more {
    background: #3488ea;
    transition: all 0.5s;
    border: 1px solid #3488ea;
    span {
      color: #fff;
    }
    .fa-angle-right {
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/News/News.vue